<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:23 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: support.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/views/support.vue
  -->

<template>
    <div>
        Support page
    </div>
</template>

<script>
    export default {
        name: "support"
    }
</script>

<style scoped>

</style>
